import { apiClient } from "../../../lib/apiClient";
import type { ApiResponse } from "../../../types/apiResponse";
import type { ProviderData } from "../types";

export const createProvider = (payload: ProviderData) => {
   return apiClient<ApiResponse>("/v1/provider", {
      method: "POST",
      body: payload
   })
}
